import { React, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import check from "../../img/like.gif";
import error from "../../img/error.gif";
import cargando from "../../img/cargando.gif";
import axios from "axios";

const mood = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "65%",
  height: "16em",
  overflow: "auto",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 22,
  p: 3,
  borderRadius: "8px",
};
const valor = "2";

const ConfirmacionID = () => {
  const [saveConfirmacion, setSaveConfirmacion] = useState([]);
  const [loading, setLoading] = useState(false);

  const sendValidation = async () => {
    var actual = new URLSearchParams(window.location.search);
    const url = `${process.env.REACT_APP_URL}formulario/Confirmacion_reclamo`;
    const header = { "Content-Type": "application/json" };
    const body = JSON.stringify({
      idreclama: actual.get("id"),
    });

    const { data } = await axios(url, {
      method: "POST",
      headers: header,
      data: body,
    });

    setSaveConfirmacion(data?.MENSAJE);
    setTimeout(() => {
      window.location.href = "/";
    }, 5000);
  };

  useEffect(() => {
    sendValidation();
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, []);

  console.log(saveConfirmacion);

  return (
    <div>
      <Box sx={mood}>
        {loading ? (
          <>
            <div className="grid justify-center ">
              {saveConfirmacion === "Se confirmo exitosamente" ? (
                <img src={`./${check}`} width="120" className="skew-y-6" />
              ) : (
                <img src={`./${error}`} width="120" />
              )}
            </div>
            <div className=" grid justify-center w-full">
              {saveConfirmacion === "Se confirmo exitosamente" ? (
                <p className="align-middle font-bold uppercase font-sans text-green-700 pt-6 justify-self-center text-center">
                  Tu confirmación del reclamo se ha vinculado exitosamente.
                  <br></br>Ya puedes cerrar esta ventana.
                </p>
              ) : (
                <p className="align-middle font-bold uppercase font-sans text-red-700 pt-6 justify-self-center text-center">
                  La confirmación del reclamo ya fue realizada.
                  <br></br>Ya puedes cerrar esta ventana.
                </p>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="grid justify-center ">
              <img src={`./${cargando}`} width="120" className="skew-y-6" />
            </div>
            <div className=" grid justify-center w-full">
              <p className="align-middle font-bold uppercase font-sans text-gray-700 pt-6 justify-self-center text-center">
                Cargando . . .
              </p>
            </div>
          </>
        )}
      </Box>
    </div>
  );
};

export default ConfirmacionID;
